// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

// Suas configurações REAIS do Firebase
// ATENÇÃO: Substitua pelos seus dados reais do Firebase do seu projeto!
const firebaseConfig = {
  apiKey: "AIzaSyB54vbZGknpsXiM1H5Uzca5tiAZFMD9xRU",
  authDomain: "cervejaria-goleador.firebaseapp.com",
  projectId: "cervejaria-goleador",
  storageBucket: "cervejaria-goleador.firebasestorage.app",
  messagingSenderId: "305584522309",
  appId: "1:305584522309:web:0d8d7fcf27bab87b680f2c",
  measurementId: "G-C8GXZQEV6P"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Exporta as instâncias de Firestore e Auth
// Cache local (IndexedDB): ao recarregar a página ou abrir outra aba, o Firebase reaproveita os
// dados já baixados e só cobra o que mudou, economizando a cota diária de leituras.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const auth = getAuth(app);